export const getInitials = (email) => {
  const username = email.split("@")[0];
  const part = username.includes("-") ? username.split("-").pop() : username;
  return part.slice(0, 2).toUpperCase();
};
